/* tslint:disable */
/* eslint-disable */
/**
 * BS BFF(ダイナミックパッケージ/DP補助金申請) API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponsePlanBasicInfoPlanImage
 */
export interface JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponsePlanBasicInfoPlanImage {
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponsePlanBasicInfoPlanImage
     */
    imageUrl?: string;
}

export function JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponsePlanBasicInfoPlanImageFromJSON(json: any): JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponsePlanBasicInfoPlanImage {
    return JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponsePlanBasicInfoPlanImageFromJSONTyped(json, false);
}

export function JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponsePlanBasicInfoPlanImageFromJSONTyped(json: any, ignoreDiscriminator: boolean): JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponsePlanBasicInfoPlanImage {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'imageUrl': !exists(json, 'imageUrl') ? undefined : json['imageUrl'],
    };
}

export function JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponsePlanBasicInfoPlanImageToJSON(value?: JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponsePlanBasicInfoPlanImage | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'imageUrl': value.imageUrl,
    };
}

